import {Component, OnChanges, OnInit, SimpleChanges} from "@angular/core";
import {ObjectBaseComponent} from "../../../../../core/shared/object/mvs-object-base/object-base.component";

@Component({
    selector: 'hc-integration-adapter-object-base-component',
    templateUrl: 'integration-adapter-type-object-base.component.html',
    styleUrls: ['integration-adapter-type-object-base.component.scss'],
    standalone: false
})

export class IntegrationAdapterTypeObjectBaseComponent extends ObjectBaseComponent implements OnInit, OnChanges {

    ngOnInit() {
        this.initialized = true
    }

    ngOnChanges(changes: SimpleChanges) {
        super.ngOnChanges(changes);
    }

}